/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Asset_Synced_To_Secure_StorageInputs */

const en_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset synced to secure storage.`)
};

const es_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo sincronizado con almacenamiento seguro.`)
};

const fr_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bien synchronisé avec le stockage sécurisé.`)
};

const de_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset mit sicherem Speicher synchronisiert.`)
};

const ja_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットがセキュアストレージに同期されました。`)
};

const zh_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资产已同步至安全存储。`)
};

const ar_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت مزامنة الأصل مع التخزين الآمن.`)
};

const id_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset disinkronkan ke penyimpanan aman.`)
};

const it_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risorsa sincronizzata con l'archiviazione sicura.`)
};

const ru_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ресурс синхронизирован с безопасным хранилищем.`)
};

const pt_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo sincronizado com o armazenamento seguro.`)
};

const ko_asset_synced_to_secure_storage = /** @type {(inputs: Asset_Synced_To_Secure_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋이 안전한 저장소에 동기화되었습니다.`)
};

/**
* | output |
* | --- |
* | "Asset synced to secure storage." |
*
* @param {Asset_Synced_To_Secure_StorageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const asset_synced_to_secure_storage = /** @type {((inputs?: Asset_Synced_To_Secure_StorageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Asset_Synced_To_Secure_StorageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_asset_synced_to_secure_storage(inputs)
	if (locale === "es") return es_asset_synced_to_secure_storage(inputs)
	if (locale === "fr") return fr_asset_synced_to_secure_storage(inputs)
	if (locale === "de") return de_asset_synced_to_secure_storage(inputs)
	if (locale === "ja") return ja_asset_synced_to_secure_storage(inputs)
	if (locale === "zh") return zh_asset_synced_to_secure_storage(inputs)
	if (locale === "ar") return ar_asset_synced_to_secure_storage(inputs)
	if (locale === "id") return id_asset_synced_to_secure_storage(inputs)
	if (locale === "it") return it_asset_synced_to_secure_storage(inputs)
	if (locale === "ru") return ru_asset_synced_to_secure_storage(inputs)
	if (locale === "pt") return pt_asset_synced_to_secure_storage(inputs)
	return ko_asset_synced_to_secure_storage(inputs)
});